import React from 'react';
import { NavLink } from 'react-router-dom';

import Button from 'components/form/Button.component';
import Icon from 'components/generic/Icon.component';
import IconStatus from 'components/generic/IconStatus.component';
import S from 'constants/string.const';
import { useTranslation } from 'providers/GILT.provider';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import alwaysNoop from 'utils/functions/nullary/alwaysNoop.util';

import CN from './NoAccessOverlay.module.scss';

const NoAccessOverlay = ({ trial, unpaid, billingLink }) => {
  const { t } = useTranslation();

  return (
    <div data-bem="NoAccessOverlay" className={CN.popupAccessOverlay}>
      <div className={CN.container}>
        <div data-bem="NoAccessOverlay__text" className={CN.content}>
          <IconStatus variant="alert" width="lg">
            <Icon variant="alert" width="l1" />
          </IconStatus>

          {fromAnyToBool(!trial) && (
            <div className={CN.flex}>
              <div className={CN.title}>{t('scheduler.noAccessOverlay.title1')}</div>
              <div className={CN.text}>{t('scheduler.noAccessOverlay.description1')}</div>
            </div>
          )}

          {fromAnyToBool(unpaid) && (
            <div className={CN.flex}>
              <div className={CN.title}>{t('scheduler.noAccessOverlay.title2')}</div>
              <div className={CN.text}>
                {t('scheduler.noAccessOverlay.description2.part1')}
                {S.space}
                <span className={CN.textBold}>{t('scheduler.noAccessOverlay.description2.part2')}</span>
                {t('scheduler.noAccessOverlay.description2.part3')}
              </div>
              <div className={CN.text}>
                {t('scheduler.noAccessOverlay.description2.part4')}
                <span className={CN.textBold}> {t('scheduler.noAccessOverlay.description2.part5')}</span>
                {S.space}
                {t('scheduler.noAccessOverlay.description2.part6')}
              </div>
            </div>
          )}

          <NavLink data-bem="NoAccessOverlay__button" to={billingLink}>
            <Button variant="primaryForce" onClick={alwaysNoop} xSpace>
              {t('scheduler.noAccessOverlay.goToButton')}
            </Button>
          </NavLink>
        </div>
      </div>
    </div>
  );
};

// noinspection JSUnusedGlobalSymbols
export default NoAccessOverlay;
